import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { MARCH_2025_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(MARCH_2025_CAMPAIGN_END_DATE);
